module.exports = function (num, base) {
  return parseInt(num.toString(), base || 8)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/octal/index.js
// module id = 176
// module chunks = 0